import axios from 'axios';
import apiCall from '../../../utils/api/api';
import {
  SET_CANCEL_TOKEN,
} from '../../actions/peopleActions/people';
import {
  CREATE_FEATURE_REQUEST,
  CREATE_FEATURE_SUCCESS,
  CREATE_FEATURE_ERROR,
  DELETE_FEATURE_REQUEST,
  DELETE_FEATURE_SUCCESS,
  DELETE_FEATURE_ERROR,
  PATCH_FEATURE_REQUEST,
  PATCH_FEATURE_SUCCESS,
  PATCH_FEATURE_ERROR,
  GET_DYNAMIC_MEDIA_FEATURE_REQUEST,
  GET_DYNAMIC_MEDIA_FEATURE_SUCCESS,
  GET_DYNAMIC_MEDIA_FEATURE_ERROR,
  GET_FEATURES_LIST_REQUEST,
  GET_FEATURES_LIST_SUCCESS,
  GET_FEATURES_LIST_ERROR,
  GET_FEATURE_REQUEST,
  GET_FEATURE_SUCCESS,
  GET_FEATURE_ERROR,
  GET_FEATURES_CMS_REQUEST,
  GET_FEATURES_CMS_SUCCESS,
  GET_FEATURES_CMS_ERROR,
  GET_FEATURE_SORT_BY_REQUEST,
  GET_FEATURE_SORT_BY_SUCCESS,
  GET_FEATURE_SORT_BY_ERROR,
  GET_FEATURE_SORT_ORDER_REQUEST,
  GET_FEATURE_SORT_ORDER_SUCCESS,
  GET_FEATURE_SORT_ORDER_ERROR,
} from '../../actions/features/features';

const state = {
  isLoading: false,
  isLoadingMedia: false,
  featuresList: [],
  pagination: {},
  feature: {},
  source: null,
  sortByOptions: [],
  sortOrderOptions: [],
  typesOptions: [],
  contentTypesOptions: [],
};

const actions = {
  [GET_FEATURES_LIST_REQUEST]: ({ commit }, params) => new Promise((resolve) => {
    if (state.source) {
      state.source.cancel();
    }

    const { CancelToken } = axios;
    const source = CancelToken.source();
    commit(SET_CANCEL_TOKEN, { token: source });

    let url = `${params.accountId}/media-collection/feature?p=${params.page}&l=15&filterField=f.title&filterValue=${params.filterValue}`;
    if (params.sortFiled) {
      url += `&s=${params.sortFiled}&d=${params.sortBy}`;
    }

    apiCall.get(url, { cancelToken: source.token })
      .then((resp) => {
        commit(GET_FEATURES_LIST_SUCCESS, resp.data);
        localStorage.setItem('features', resp.data.pagination.page);
        resolve();
      })
      .catch(() => {
        commit(GET_FEATURES_LIST_ERROR);
      });
  }),
  [CREATE_FEATURE_REQUEST]: ({ commit }, { accountId, data }) => new Promise((resolve, reject) => {
    commit(CREATE_FEATURE_REQUEST);

    apiCall.post(`${accountId}/media-collection/feature`, data)
      .then((res) => {
        commit(CREATE_FEATURE_SUCCESS, res.data);
        resolve(res.data);
      })
      .catch((err) => {
        const error = err.response.data;
        commit(CREATE_FEATURE_ERROR, error);
        reject(error);
      });
  }),
  [GET_FEATURE_REQUEST]: ({ commit }, { accountId, featureId }) => new Promise(
    (resolve, reject) => {
      commit(GET_FEATURE_REQUEST);

      const url = `${accountId}/media-collection/feature/${featureId}`;

      apiCall.get(url)
        .then((resp) => {
          commit(GET_FEATURE_SUCCESS, resp.data);
          resolve(resp.data);
        })
        .catch((err) => {
          const error = err.response.data;
          commit(GET_FEATURE_ERROR, error);
          reject(error);
        });
    },
  ),
  [PATCH_FEATURE_REQUEST]:
    ({ commit }, {
      accountId, featureId, isSilent = false, data,
    }) => new Promise((resolve, reject) => {
      commit(PATCH_FEATURE_REQUEST, isSilent);

      apiCall.patch(`${accountId}/media-collection/feature/${featureId}`, data)
        .then((resp) => {
          commit(PATCH_FEATURE_SUCCESS, resp);
          resolve(resp);
        })
        .catch((err) => {
          const error = err.response.data;
          commit(PATCH_FEATURE_ERROR, error);
          reject(error);
        });
    }),
  [DELETE_FEATURE_REQUEST]:
    ({ commit }, { accountId, featureId }) => new Promise((resolve, reject) => {
      commit(DELETE_FEATURE_REQUEST);

      apiCall.delete(`${accountId}/media-collection/feature/${featureId}`)
        .then((resp) => {
          commit(DELETE_FEATURE_SUCCESS, resp.data);
          resolve();
        })
        .catch((err) => {
          const error = err.response.data;
          commit(DELETE_FEATURE_ERROR, error);
          reject(error);
        });
    }),
  [GET_FEATURE_SORT_BY_REQUEST]: ({ commit }) => new Promise((resolve) => {
    const url = 'choice/feature/sort-by';

    apiCall.get(url)
      .then((resp) => {
        commit(GET_FEATURE_SORT_BY_SUCCESS, resp.data.data);
        resolve();
      })
      .catch(() => {
        commit(GET_FEATURE_SORT_BY_ERROR);
      });
  }),
  [GET_FEATURE_SORT_ORDER_REQUEST]: ({ commit }) => new Promise((resolve) => {
    const url = 'choice/feature/sort-direction';

    apiCall.get(url)
      .then((resp) => {
        commit(GET_FEATURE_SORT_ORDER_SUCCESS, resp.data.data);
        resolve();
      })
      .catch(() => {
        commit(GET_FEATURE_SORT_ORDER_ERROR);
      });
  }),
  [GET_DYNAMIC_MEDIA_FEATURE_REQUEST]: ({ commit }, params) => new Promise((resolve, reject) => {
    commit(GET_DYNAMIC_MEDIA_FEATURE_REQUEST);
    let dynamicParams = '';
    if (params.mediaFolder) {
      dynamicParams += `&folders=${params.mediaFolder}`;
    }

    if (params.includeMediaTypes) {
      params.includeMediaTypes.forEach((tag) => {
        dynamicParams += `&includeMediaTypes[]=${tag}`;
      });
    }

    if (params.includeContentTypes) {
      params.includeContentTypes.forEach((tag) => {
        dynamicParams += `&includeContentTypes[]=${tag}`;
      });
    }

    if (params.isHideChildren) {
      dynamicParams += '&showChildren=0';
    }

    const url = `${params.accountId}/media-collection/item/search?p=
  ${params.page}&l=${params.allLength}&filterField=title&s=${params.sortBy}&d=${params.sortOrder
  || params.sortDirection}&checkAvailability=${params.checkAvailability}${dynamicParams}`;

    apiCall.get(url)
      .then((resp) => {
        commit(GET_DYNAMIC_MEDIA_FEATURE_SUCCESS, resp.data);
        resolve(resp.data.data);
      }).catch((error) => {
        commit(GET_DYNAMIC_MEDIA_FEATURE_ERROR);
        reject(error);
      });
  }),
  [GET_FEATURES_CMS_REQUEST]: ({ commit }, { accountId }) => new Promise((resolve) => {
    commit(GET_FEATURES_CMS_REQUEST);
    const url = `choice/accounts/${accountId}}/features`;

    apiCall.get(url)
      .then((resp) => {
        commit(GET_FEATURES_CMS_SUCCESS, resp.data);
        resolve(resp.data);
      })
      .catch(() => {
        commit(GET_FEATURES_CMS_ERROR);
      });
  }),
};

const mutations = {
  [GET_FEATURES_LIST_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_FEATURES_LIST_SUCCESS]: (state, payload) => {
    state.isLoading = false;
    state.featuresList = payload.data;
    state.pagination = payload.pagination;
    state.source = null;
  },
  [CREATE_FEATURE_REQUEST]: () => {
    state.isLoading = true;
  },
  [CREATE_FEATURE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [CREATE_FEATURE_ERROR]: () => {
    state.isLoading = false;
  },
  [PATCH_FEATURE_REQUEST]: (state, isSilent) => {
    if (isSilent) return;
    state.isLoading = true;
  },
  [PATCH_FEATURE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [PATCH_FEATURE_ERROR]: () => {
    state.isLoading = false;
  },
  [DELETE_FEATURE_REQUEST]: () => {
    state.isLoading = true;
  },
  [DELETE_FEATURE_SUCCESS]: () => {
    state.isLoading = false;
  },
  [DELETE_FEATURE_ERROR]: () => {
    state.isLoading = false;
  },
  [GET_FEATURE_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_FEATURE_SUCCESS]: (state, payload) => {
    state.isLoading = false;
    state.playlist = payload;
  },
  [GET_FEATURE_ERROR]: () => {
    state.isLoading = false;
  },
  [GET_FEATURES_CMS_REQUEST]: () => {
    state.isLoading = true;
  },
  [GET_FEATURES_CMS_SUCCESS]: (state) => {
    state.isLoading = false;
  },
  [GET_FEATURES_CMS_ERROR]: () => {
    state.isLoading = false;
  },
  [SET_CANCEL_TOKEN]: (payload) => {
    state.source = payload.token;
  },
  [GET_FEATURE_SORT_BY_SUCCESS]: (state, payload) => {
    state.sortByOptions = payload;
  },
  [GET_FEATURE_SORT_ORDER_SUCCESS]: (state, payload) => {
    state.sortOrderOptions = payload;
  },
  [GET_DYNAMIC_MEDIA_FEATURE_REQUEST]: (state) => {
    state.isLoadingMedia = true;
  },
  [GET_DYNAMIC_MEDIA_FEATURE_SUCCESS]: () => {
    state.isLoadingMedia = false;
  },
  [GET_DYNAMIC_MEDIA_FEATURE_ERROR]: () => {
    state.isLoadingMedia = false;
  },
};

export default {
  state,
  actions,
  mutations,
};
